export const RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
export const RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA =
	'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
export const RESOURCE_TYPE_RAPIDBOARDS_RESOURCE = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';

export const RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';

export const WRM_RESOURCES_ARRAY: string[] = [
	'_super',
	'wrc!greenhopper-rapid-non-gadget',
	'wrc!gh-rapid',
	'wrc!jira.global',
	'wrc!jira.general',
	'wrc!atl.global',
	// Required to prevent an error on initial loading of reports
	'wrc!jira.webresources:header',
	// Required for Control Chart report page
	'wrc!jira.webresources:calendar',
	'wrc!jira.webresources:calendar-en',
	'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
	// Required for explicit usage of jQuery
	'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
	// Required for the styles of the toggle button when transitioning from reports to board settings
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
	// Required for the profile card in board settings, that doesn't really render because it has wrong
	// parameters and it has been broken for ages, but at least prevents noisy errors
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
	'wrc!gh-rapid-config',
	'wrc!gh-rapid-analytics',
	'wrc!gh-rapid-charts',
	'wrc!jira.webresources:mentions-feature',
	'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx',
];

export const WRM_HERITAGE_RESOURCES_FHD_ARRAY: Array<string> = [];

export const WRM_BOARD_RESOURCES_FHD_ARRAY: string[] = [
	'wrc!gh-rapid-lwf-board-fhd',
	'wrc!jira.webresources:skate',
	'wrc!jira.webresources:feature-flags',
	'wrc!com.atlassian.auiplugin:aui-spinner',
	'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
	'wrc!com.atlassian.analytics.analytics-client:js-events',
];

export const WRM_BACKLOG_RESOURCES_FHD_ARRAY: string[] = [
	'wrc!gh-rapid-backlog-fhd',
	'wrc!jira.webresources:skate',
	'wrc!jira.webresources:header',
	'wrc!jira.webresources:feature-flags',
	'wrc!com.atlassian.auiplugin:aui-spinner',
	'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
	'wrc!com.atlassian.analytics.analytics-client:js-events',
];
